import state from './state'
import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'
import createPersistedState from 'vuex-persistedstate'

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  state,
  getters,
  mutations,
  actions,
  plugins: [createPersistedState()] // adicionar state no localStorage
}
